import React from "react";

const IconAi = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.463867" width="48" height="48" rx="24" fill="#006F94" />
      <path
        d="M18.1565 16.2282C21.8073 13.7955 26.7847 14.1896 30.0056 17.4106C33.6757 21.0807 33.6757 27.031 30.0056 30.7011C26.3356 34.3711 20.3852 34.3711 16.7152 30.7011C14.5466 28.5325 13.6594 25.5677 14.0536 22.7476"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M30.0057 30.7009L32.0914 32.7866"
        stroke="white"
        stroke-width="1.27636"
      />
      <rect
        x="31.2266"
        y="34.281"
        width="3.3366"
        height="4.99336"
        transform="rotate(-45 31.2266 34.281)"
        stroke="white"
        stroke-width="1.27636"
        stroke-linecap="square"
      />
      <path
        d="M18.5028 28.8413L21.4226 22.3681H22.4693L25.3891 28.8413H24.1312L23.3508 27.0233L23.8741 27.4181H19.9994L20.5136 27.0233L19.7423 28.8413H18.5028ZM21.9184 23.6628L20.6421 26.7019L20.4034 26.4265H23.4701L23.2406 26.7019L21.9551 23.6628H21.9184ZM26.2934 28.8413V22.3681H27.5146V28.8413H26.2934Z"
        fill="white"
      />
      <path
        d="M11.8663 19.3318C14.1826 19.3318 16.0602 17.4542 16.0602 15.1379C16.0602 17.4542 17.9379 19.3318 20.2541 19.3318C17.9379 19.3318 16.0602 21.2095 16.0602 23.5257C16.0602 21.2095 14.1826 19.3318 11.8663 19.3318"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M19.2721 9.11523C19.2721 10.3524 18.2692 11.3554 17.032 11.3554C18.2692 11.3554 19.2721 12.3584 19.2721 13.5956C19.2721 12.3584 20.2751 11.3554 21.5123 11.3554C20.2751 11.3554 19.2721 10.3524 19.2721 9.11523Z"
        fill="white"
      />
      <path
        d="M17.032 11.3554C18.2692 11.3554 19.2721 10.3524 19.2721 9.11523C19.2721 10.3524 20.2751 11.3554 21.5123 11.3554C20.2751 11.3554 19.2721 12.3584 19.2721 13.5956C19.2721 12.3584 18.2692 11.3554 17.032 11.3554"
        stroke="white"
        stroke-width="1.27636"
      />
      <path
        d="M10.6393 24.4121C10.6393 25.3819 9.85307 26.1681 8.88324 26.1681C9.85307 26.1681 10.6393 26.9543 10.6393 27.9242C10.6393 26.9543 11.4255 26.1681 12.3953 26.1681C11.4255 26.1681 10.6393 25.3819 10.6393 24.4121Z"
        fill="white"
      />
      <path
        d="M8.88324 26.1681C9.85307 26.1681 10.6393 25.3819 10.6393 24.4121C10.6393 25.3819 11.4255 26.1681 12.3953 26.1681C11.4255 26.1681 10.6393 26.9543 10.6393 27.9242C10.6393 26.9543 9.85307 26.1681 8.88324 26.1681"
        stroke="white"
        stroke-width="1.27636"
      />
    </svg>
  );
};

export default IconAi;
